import {
  MandateState,
  PropertyType,
  Source,
  Status,
  type RefundReason,
  type SellerLead,
} from '@smg-real-estate/seller-leads-schema';

// modals
export interface SearchFilters {
  searchText?: string;
  status?: Status[];
  source?: Source[];
  sortOrder: Sort;
  qualified?: QualifiedOptions[];
  mandateState?: MandateState[];
}

export interface LeadsRequestBody {
  page: number;
  pageSize: number;
  filters: SearchFilters;
}

export interface LeadsResponseBody extends LeadsRequestBody {
  leads: SellerLead[];
  totalItems: number;
}

export interface LeadResponse {
  statusCode: number;
  results: SellerLead | null;
}

// view modals
export interface DisplayableLeadImage {
  url: string;
  alt: string;
}

export interface DisplayableLead {
  leadId: string;
  propertyType: PropertyType;
  address: string;
  shortAddress: string;
  name: string;
  phoneNumber: string;
  phoneVerified: boolean;
  mail: string;
  splicingAddress: string;
  status: Status;
  mandateState?: MandateState;
  purchasedDate: string;
  purchasedDateWithTime: string;
  purchasedDateUTC: string;
  source: LeadSource;
  priceRange: string;
  price: string;
  livingSpace: string;
  lotSize: string;
  rooms: string;
  title: string;
  images: DisplayableLeadImage[];
  isRefundRequested: boolean;
  isRefundAccepted: boolean;
  isRefundRefused: boolean;
  isRefund: boolean;
  isQualified: boolean;
  noteForAgency: string;
  selectedAgent?: string;
  refusedRefundDate?: string;
  refundRequestDate?: string;
  acceptedRefundDate?: string;
  leadSoldPrice?: string;
  brokerCommission: string;
  commissionShare: string;
  refundAgencyComment?: string;
  refundAdminComment?: string;
  refundReason: RefundReason | null;
  yearBuild: string;
}

export enum LeadSource {
  Anibis = 'anibis',
  Homegate = 'hg',
  Immoscout24 = 'is24',
  Tutti = 'tutti',
  Flatfox = 'flatfox',
}

export const LeadSourceToDisplayableSource: Record<Source, LeadSource> = {
  [Source.AnibisInsertion]: LeadSource.Anibis,
  [Source.HgPropEvaluation]: LeadSource.Homegate,
  [Source.Is24PropEvaluation]: LeadSource.Immoscout24,
  [Source.Iv24Evaluation]: LeadSource.Immoscout24,
  [Source.Iv24Phone]: LeadSource.Immoscout24,
  [Source.TuttiInsertion]: LeadSource.Tutti,
  [Source.TuttiForced]: LeadSource.Tutti,
  [Source.TuttiOption]: LeadSource.Tutti,
  [Source.Flatfox]: LeadSource.Flatfox,
  [Source.Is24PropEvaluationHODB]: LeadSource.Immoscout24,
  [Source.HgPropEvaluationHODB]: LeadSource.Homegate,
  [Source.Aroundhome]: LeadSource.Immoscout24,
  [Source.Hausheld]: LeadSource.Immoscout24,
  [Source.Iv24Direct]: LeadSource.Immoscout24,
};

export const LeadSourceToOriginSource: Record<LeadSource, Array<Source>> = {
  [LeadSource.Anibis]: [Source.AnibisInsertion],
  [LeadSource.Homegate]: [Source.HgPropEvaluation, Source.HgPropEvaluationHODB],
  [LeadSource.Immoscout24]: [
    Source.Is24PropEvaluation,
    Source.Is24PropEvaluationHODB,
    Source.Aroundhome,
    Source.Hausheld,
    Source.Iv24Evaluation,
    Source.Iv24Phone,
    Source.Iv24Direct,
  ],
  [LeadSource.Tutti]: [Source.TuttiInsertion, Source.TuttiForced, Source.TuttiOption],
  [LeadSource.Flatfox]: [Source.Flatfox],
};

export enum Sort {
  Desc = 'DESC',
  Asc = 'ASC',
}

export enum QualifiedOptions {
  Qualified = 'qualified',
  Unqualified = 'unqualified',
}
export interface SelectedStatus {
  status: Status;
  mandateState: MandateState | null;
}

export const SEARCH_TEXT_MIN_LENGTH = 3;
